export enum ButtonTypes {
 'Primary' = 'primary',
 'Secondary' = 'secondary',
 'Tertiary' = 'tertiary',
 'Quaternary' = 'quaternary'
}